var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.84375C0 5.39603 0.447715 5.84375 1 5.84375H1.07143V14.875C1.07143 15.4386 1.29719 15.9791 1.69906 16.3776C2.10092 16.7761 2.64596 17 3.21429 17H11.7857C12.354 17 12.8991 16.7761 13.3009 16.3776C13.7028 15.9791 13.9286 15.4386 13.9286 14.875V5.84375H14C14.5523 5.84375 15 5.39603 15 4.84375V4.71875C15 4.16647 14.5523 3.71875 14 3.71875H11.25V2.125C11.25 1.56141 11.0242 1.02091 10.6224 0.622398C10.2205 0.223883 9.67546 0 9.10714 0H5.89286C5.32454 0 4.77949 0.223883 4.37763 0.622398C3.97577 1.02091 3.75 1.56141 3.75 2.125V3.71875H1C0.447715 3.71875 0 4.16647 0 4.71875V4.84375ZM11.7857 14.875H3.21429V5.84375H11.7857V14.875ZM5.89286 2.125H9.10714V3.71875H5.89286V2.125Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.520750f1acf57a41efc0d245b9abe538.svg";
export { ForwardRef as ReactComponent };